// Global configuration constants
export const MAX_WIDTH = 504;
export const ONBOARDING_HINTS = true;
export const PERFECT_SCREEN_GOLDEN_GLOW = false;
export const DONT_SHOW_PAR_FOR_UNSOLVED_LEVELS = true;
// Configuration: unlock hour for daily levels (0 = midnight, 2 = 2am)
export const DAILY_UNLOCK_HOUR = 0;

// Configuration: enable inset drawing in tile shapes
export const ENABLE_INSET_DRAWING = false;

// Configuration: icon size in pixels for level icons
export const ICON_SIZE = 55;
